import { confirmAlert } from 'react-confirm-alert';
import { Button, Card as CardFolder, CardBody, CardTitle, Col, Container, Row } from 'reactstrap';
import { DocumentsStateManager } from './DocumentsStateManager';
import DocumentsInterface from '../../../interfaces/DocumentsInterface';

export const deleteItemAlert = async (card: DocumentsInterface, documentStateMachine: DocumentsStateManager) => {
  confirmAlert({
    customUI: ({ onClose }) => {
      return (
        <Container fluid>
          <CardFolder>
            <CardBody>
              <CardTitle tag="h5" className="text-uppercase text-muted mb-0">
                Delete
              </CardTitle>
              <Row className="mt-3">
                <Col md="12 text-center">
                  <span className="h2 font-weight-bold mb-0">{`Are you sure to delete item: ${card.name}?`}</span>
                </Col>
              </Row>
              <Row className="mt-5">
                <Col md="6 text-center">
                  <Button
                    color="primary"
                    href={document.location}
                    onClick={async () => {
                      await documentStateMachine.deleteFile(card.id);
                      onClose();
                      documentStateMachine.doRefresh();
                    }}
                    size="lg"
                    style={{ minWidth: '100px' }}
                  >
                    Yes
                  </Button>
                </Col>
                <Col md="6 text-center">
                  <Button
                    color="danger"
                    href={document.location}
                    onClick={(e) => {
                      e.preventDefault();
                      onClose();
                    }}
                    size="lg"
                    style={{ minWidth: '100px' }}
                  >
                    No
                  </Button>
                </Col>
              </Row>
            </CardBody>
          </CardFolder>
        </Container>
      );
    },
  });
};
